import React, { useState, useEffect } from "react";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { useSelector } from "react-redux";
import { USERS_API_04 } from "../../api/ApiModel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import AddToolbar from "../../components/common/AddToolbar";
import dayjs from "dayjs";
import { MenuItem } from "@mui/material";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  MSG_UPDATE_ACC_FAILED,
  MSG_UPDATE_ACC_SUCCESS,
} from "../../utils/sys/Messages";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";

const accountStatus = [
  {
    value: CON_STATUS_ACTIVE,
    label: "Active User Account",
  },
  {
    value: "D",
    label: "Inactive User Account",
  },
];

function UpdateAccount({}) {
  const [errors, setErrors] = useState({});
  const location = useLocation();
  const { userRefCode, username } = location.state || {};
  console.log("userRefCode", userRefCode);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const today = dayjs().format("YYYY-MM-DD");
  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, USERREFCODE, USERNAME, STOREDATE, SETUPDATE } =
    SYS_USER.USER_PARAM || {};

  const [selectedItemDetails, setSelectedItemDetails] = useState({
    userrefcode: String(userRefCode) || "", // Example value, replace with actual data
    compcode: COMPCODE,
    newpassword: "0",
    reason: "",
    uptodate: today,
    sts: CON_STATUS_ACTIVE, // Default to Active
    locdate: new Date().toISOString().split("T")[0],
    enuser: USERNAME,
  });

  const validateFields = () => {
    let validationErrors = {};
    // if (!selectedItemDetails.uptodate)
    //   validationErrors.uptodate = "Date is required";
    if (!selectedItemDetails.reason)
      validationErrors.reason = "Reason is required";
    // if (!selectedItemDetails.sts) validationErrors.sts = "Status is required";
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };
  const gotToPage = () => {
    navigate("/ViewUsers");
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleClearClick = () => {
    setSelectedItemDetails({
      userrefcode: "",
      compcode: "",
      newpassword: "",
      reason: "",
      uptodate: "",
      sts: "",
      locdate: "",
      enuser: "",
    });
    setErrors({});
  };

  const handleDropdownChange = (event) => {
    const { value } = event.target;
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      sts: value,
    }));
  };

  // const handleDateChange = (date) => {
  //   setSelectedItemDetails((prevState) => ({
  //     ...prevState,
  //     uptodate: date ? date : null,
  //   }));
  // };

  const handleDateChange = (event) => {
    const date = event.target.value ? dayjs(event.target.value) : null;
    setSelectedItemDetails((prevState) => ({
      ...prevState,
      uptodate: date,
    }));
  };

  // const handleReasonChange = (event) => {
  //   const { value } = event.target;
  //   setSelectedItemDetails((prevState) => ({
  //     ...prevState,
  //     reason: value,
  //   }));
  // };

  const handleUpdateAccount = async () => {
    if (!validateFields()) return;
    try {
      console.log("Payload for API call:", selectedItemDetails);

      const response = await externalpostApi(USERS_API_04, selectedItemDetails);
      console.log("API Response:", response);

      setSnackbarMessage("Account Updated Successfully!");
      setOpenSnackbar(true);

      setSnackbarMessage(MSG_UPDATE_ACC_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Reset form
      setSelectedItemDetails((prevState) => ({
        ...prevState,
        reason: "",
        uptodate: "",
        sts: CON_STATUS_ACTIVE, // Reset dropdown to default
      }));

      setTimeout(() => {
        // navigate("/ViewUsers");
      }, 2000);
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(MSG_UPDATE_ACC_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedItemDetails((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // Clear specific field error
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Users</Link>
                <Link underline="none">Update Accounts</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToPage}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                  id="btnback"
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box sx={styles.AI_AddStyledBox}>
        <AddToolbar
          label={{
            name: (
              <>
                Update User Account :{" "}
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: theme.palette.text.secondary,
                  }}
                >
                  {username}
                </span>
              </>
            ),
          }}
        />

        <Grid container spacing={2} sx={styles.AI_container}>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              type="date"
              fullWidth
              size="small"
              label="Up to Date"
              value={
                selectedItemDetails.uptodate
                  ? dayjs(selectedItemDetails.uptodate).format("YYYY-MM-DD")
                  : today
              }
              // value={selectedItemDetails.uptodate||
              // today
              // }
              onChange={handleDateChange} // Update your change handler for date
              error={!!errors.uptodate}
              helperText={errors.uptodate}
              InputLabelProps={{
                shrink: true, // Ensure the label stays displayed when date is picked
              }}
              inputProps={{
                min: today, // Disable past dates
              }}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              id="Account-Status"
              select
              fullWidth
              size="small"
              label="Account Status"
              value={selectedItemDetails.sts}
              onChange={handleDropdownChange}
              error={!!errors.sts}
              helperText={errors.sts}
            >
              {accountStatus.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item lg={6} md={6} xs={12} sm={12}>
            <TextField
              size="small"
              fullWidth
              id="reason"
              label="Reason"
              variant="outlined"
              name="reason"
              multiline
              rows={4}
              value={selectedItemDetails.reason}
              onChange={handleInputChange}
              error={!!errors.reason}
              helperText={errors.reason}
            />
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px", // Space between the image and button
              padding: "20px",
            }}
          ></Box>
        </Grid>
        <Stack
          direction="row"
          spacing={2}
          m={1}
          justifyContent="flex-end"
          padding={1}
        >
          <Button
            variant="outlined"
            sx={styles.AI_button1}
            onClick={handleClearClick}
            id="btnclr"
          >
            Clear
          </Button>
          <Button
            variant="contained"
            sx={styles.AI_button2}
            onClick={handleUpdateAccount}
            id="btnconfirm"
          >
            Confirm
          </Button>
        </Stack>
      </Box>

      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </div>
  );
}

export default UpdateAccount;
